import React from 'react';
import HistoryCard from '../Components/HistoryCard/HistoryCard';
import useSiteContent, { imageUrl } from '../Content/useSiteContent';
import ContentNotice from '../Content/ContentNotice';

const History = () => {
  const { data, unavailable } = useSiteContent('history');
  return <div className="main_page_container">
    <ContentNotice unavailable={unavailable} />
    <h1 className="page_title">History</h1>
    <div>{data.items.map((submarine, index) => <HistoryCard key={index} {...submarine} image={imageUrl(submarine.image)} />)}</div>
  </div>;
};
export default History;
